import { Component } from '@angular/core';
import { AccountRepository } from '@timechef/features/account/state';

@Component({
  selector: 'app-cgu-loyalty',
  templateUrl: './cgu-loyalty.component.html',
  styleUrls: ['./cgu-loyalty.component.scss'],
  standalone: false,
})
export class CguLoyaltyComponent {
  language$ = this.accountRepo.language$;

  constructor(private accountRepo: AccountRepository) {}
}
